export default "__VITE_ASSET__8e8fe068__"